import { Controller } from "@hotwired/stimulus"
import Big from "big.js"

export default class CostCalculatorController extends Controller {
  static values = { avgCost: String }
  static targets = ["quantity", "totalCost"]

  declare avgCostValue: string
  declare quantityTarget: HTMLInputElement
  declare totalCostTarget: HTMLInputElement

  calculate(): void {
    const qty = this.quantityTarget.value.trim()
    if (!qty || !this.avgCostValue) return

    try {
      const total = new Big(this.avgCostValue).times(qty)
      this.totalCostTarget.value = total.toFixed(2)
    } catch {
      // invalid input — leave total_cost unchanged
    }
  }
}
